import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { AuthenticationService } from '../services/authentication.service';
import { LocalStorageService } from '../services/local-storage-service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private localStorageService: LocalStorageService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentUser = this.authenticationService.currentUserValue;
        const isAdminApiUrl = request.url.startsWith(environment.adminApiUrl);
        const isSuperAdminApiUrl = request.url.startsWith(environment.superAdminApiUrl);
        const token = this.localStorageService.getItem('token');
        if (currentUser && (isAdminApiUrl || isSuperAdminApiUrl)) {
            request = request.clone({
                headers: request.headers.set('token', token)
            });
        }

        return next.handle(request);
    }
}